import { endOfMonth } from 'date-fns'
import { RevenueCardProps } from './types'
import { getTrendText } from './utils'
import {
  NEUTRAL_COLOR,
  getTrendSymbol,
  getTrendColor
} from '../common/utils'
import {
  formatPrice,
  formatToPercentage
} from '../../../../../../utils/format'
import {
  ProjectionLabel,
  ProjectionValue,
  ProjectionWrapper,
  TrendText
} from './styles'
import {
  CardContainer,
  CardTitle,
  TrendWrapper,
  ValueWrapper,
  StickyBottomWrapper
} from '../common/styles'
import { BootstrapTooltip } from 'components/BootstrapTooltip'
import { UnavailableValue } from 'components/UnavailableValue'
import {
  FUTURE_SALES_MESSAGE,
  getDisabledFieldMessage,
  isFieldDisabled
} from 'utils/reportDisabledFields'

export const RevenueCard = ({
  valueDisabledReason,
  value = 0,
  projectionValue = 0,
  projectionDisabledReason,
  lastYearPercentage,
}: RevenueCardProps) => {
  const valueDisabled = isFieldDisabled(valueDisabledReason)
  const trendColor = !valueDisabled && typeof lastYearPercentage === 'number'
    ? getTrendColor(lastYearPercentage)
    : NEUTRAL_COLOR

  const currentDate = new Date()
  const formattedDate = endOfMonth(currentDate).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })

  return (
    <CardContainer>
      <CardTitle>FATURAMENTO</CardTitle>

      <ValueWrapper>
        {valueDisabled
          ? (
            <BootstrapTooltip title={FUTURE_SALES_MESSAGE}>
              <span>-</span>
            </BootstrapTooltip>
            )
          : formatPrice(value)}
      </ValueWrapper>

      <StickyBottomWrapper>
        {typeof lastYearPercentage === 'number' && (
          valueDisabled
            ? (
              <UnavailableValue message={FUTURE_SALES_MESSAGE}>
                <TrendWrapper component='span' color={trendColor}>-</TrendWrapper>
              </UnavailableValue>
              )
            : (
              <TrendWrapper color={trendColor}>
                {getTrendSymbol(lastYearPercentage)}
                {' '}
                {formatToPercentage(Math.abs(lastYearPercentage))}
                <TrendText>{getTrendText(lastYearPercentage)}</TrendText>
              </TrendWrapper>
              )
        )}

        <ProjectionWrapper>
          <ProjectionLabel>Previsão - para {formattedDate}</ProjectionLabel>
          <ProjectionValue>
            {isFieldDisabled(projectionDisabledReason)
              ? (
                <BootstrapTooltip
                  title={getDisabledFieldMessage(projectionDisabledReason)}
                >
                  <span>-</span>
                </BootstrapTooltip>
                )
              : formatPrice(projectionValue)}
          </ProjectionValue>
        </ProjectionWrapper>
      </StickyBottomWrapper>
    </CardContainer>
  )
}
